import type { PortalWidgetStatus } from "@entrilia/shared/api/portalWidgetsTypes";

export interface InvestorPortalSettingsResponse {
  settings: InvestorPortalSettings;
}

export interface InvestorPortalSettings {
  enabledFeatures?: InvestorPortalFeature[];
  enabledPreviewOnlyFeatures?: InvestorPortalFeature[];
  appBarColor: string;
  appBarTextColor: string;
  mainColor: string;
  logoTypeUrl: string;
  logoTypeSize: RelativeLogoSize;
  logoMarkUrl: string;
  faviconUrl: string;
  bannerUrl: string;
  bannerFontColor: string;
  supportEmail: string;
  supportPhone: string;
  contactInvitationEmailSubject: string;
  contactInvitationEmailMessageText: string;
  contactInvitationEmailCompanyLogoUrl: string;
  contactInvitationEmailLinkButtonColor: string;
  contactInvitationEmailCC: string;
  contactInvitationEmailBCC: string;
  downloadFileNameFormat: DownloadFileNameFormatOptions;
  enableAutomaticInvites: boolean;
}

export interface InvestorPortalSettingsUpdate {
  enabledFeatures?: InvestorPortalFeature[];
  enabledPreviewOnlyFeatures?: InvestorPortalFeature[];
  supportEmail?: string;
  supportPhone?: string;
  contactInvitationEmailSubject?: string;
  contactInvitationEmailMessageText?: string;
  contactInvitationEmailCC?: string;
  contactInvitationEmailBCC?: string;
  downloadFileNameFormat?: DownloadFileNameFormatOptions;
  enableAutomaticInvites?: boolean;
}

export interface FundPortalCoreBrandingSettingsUpdate {
  appBarColor?: string;
  appBarTextColor?: string;
  mainColor?: string;
  logoTypeSize?: RelativeLogoSize;
  faviconUrlImage?: File;
  logoTypeUrlImage?: File;
  logoMarkUrlImage?: File;
  bannerFontColor?: string;
  bannerUrlImage?: File;
}

export interface FundPortalCoreBrandingSettings {
  appBarColor: string;
  appBarTextColor: string;
  mainColor: string;
  logoTypeUrl: string;
  logoTypeSize: RelativeLogoSize;
  logoMarkUrl: string;
  faviconUrl: string;
  bannerUrl: string;
  bannerFontColor: string;
}

export const allInvestorPortalFeatures = [
  "Inbox",
  "Dashboards",
  "News",
  "Fundraising",
  "AccountSettingsViewer",
  "AccountSettingsEditor",
  "BankAccountsDetailsViewer",
  "BankAccountsDetailsEditor",
  "Membership",
  "MembershipEditor",
  "PortfolioCompanies",
] as const;

export type InvestorPortalFeature = "All" | (typeof allInvestorPortalFeatures)[number];

export type RelativeLogoSize = "Small" | "Medium" | "Large";

export type DownloadFileNameFormatOptions = "OriginalFileName" | "FundInvestorDocument";

export interface SendTestInvitationEmailRequest {
  recipientEmail: string;
  contactId: string;
}

export interface TestInvitationContactsResponse {
  contacts: TestInvitationContact[];
}

export interface TestInvitationContact {
  id: string;
  fullName: string;
  email: string;
}

export interface InvestorPortalWatermarkSettings {
  isEnabled: boolean;
  segments: WatermarkSegment[];
  customText?: string;
  externalCategoryIds?: string[];
  showDateWithoutTime: boolean;
}

export type WatermarkSegment = "ContactName" | "ContactEmail" | "InvestorName" | "DateAndTime" | "CustomText";

export interface InvestorPortalSyncStatus {
  isSyncActive: boolean;
  lastSyncTimestamp?: string;
}

export interface SignOnSettings {
  primaryThemeColor?: string;
  useBackgroundImage: boolean;
  backgroundColor?: string;
  backgroundImageUrl?: string;
  clientLogoUrl?: string;
}

export interface UpdateSignOnSettingsRequest {
  primaryThemeColor?: string;
  useBackgroundImage?: boolean;
  backgroundColor?: string;
  backgroundImage?: File;
  clientLogo?: File;
}

export interface UpdatePortalWidgetRequest {
  name?: string;
  reportId?: string;
  status?: PortalWidgetStatus;
  includeRowDetails?: boolean;
  footnoteUserInput?: string;
}
